// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QUNQ","tabsBox":"styles_tabsBox__3_KOq","createButton":"styles_createButton__3EEiz"};